import React from 'react'
import { CSSProperties } from 'styled-components'
import { EReportingMetricNumberType } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { sanitizeDataTestId } from '../../../utils/sanitizeDataTestId'
import {
  EllipsisContainer,
  SVGContainer,
  Container,
  IconCircleCrossSmall,
  Text,
  IconButton,
} from '../../Global'
import { TGlobalMetrics } from '../models'

export function MetricWidget({
  id,
  value,
  translatedMetricName = '',
  metricName = '',
  description,
  borderBottomColor = 'var(--border-color-default)',
  isSelected = false,
  onClick = () => {},
  onRemove = () => {},
}: {
  id: TGlobalMetrics
  value: string
  translatedMetricName?: string
  metricName?: string
  description?: EReportingMetricNumberType
  isSelected?: boolean
  onClick?: (header: TGlobalMetrics) => void
  onRemove?: (header: TGlobalMetrics) => void
} & Pick<CSSProperties, 'borderBottomColor'>) {
  return (
    <Container
      width="100%"
      padding="var(--margin-default)"
      border={{
        width: '1px',
        style: 'solid',
        color: 'var(--border-color-default)',
        radius: '4px',
      }}
      borderBottom={{
        width: '3px',
        color: isSelected ? borderBottomColor : 'var(--border-color-default)',
        radius: '1.5px',
      }}
      /* style={{
        boxShadow: isSelected ? '0px 0px 8px 4px rgba(0,0,0,0.2)' : '',
      }} */
    >
      <Container display="flex" alignItems="center">
        <EllipsisContainer
          flex="1"
          preset="paragraph opensans"
          cursor="pointer"
          onClick={() => onClick(id)}
        >
          <Text
            data-testid={sanitizeDataTestId(`chart-metric-name-${metricName}`)}
          >
            {translatedMetricName}
          </Text>
        </EllipsisContainer>
        <SVGContainer opacity="0.5">
          <IconButton
            onClick={() => onRemove(id)}
            data-testid={sanitizeDataTestId(`chart-metric-cross-${metricName}`)}
          >
            <IconCircleCrossSmall />
          </IconButton>
        </SVGContainer>
      </Container>
      <Container
        display="flex"
        alignItems="center"
        cursor="pointer"
        onClick={() => onClick(id)}
      >
        <EllipsisContainer preset="h5" padding="0 var(--margin-default) 0 0">
          <Text
            data-testid={sanitizeDataTestId(`chart-metric-value-${metricName}`)}
          >
            {value}
          </Text>
        </EllipsisContainer>
        <EllipsisContainer preset="paragraph small opensans" opacity="0.5">
          <Text>{description}</Text>
        </EllipsisContainer>
      </Container>
    </Container>
  )
}
